<lex-doc-viewer-context-panel-template>
  <div context-body>
    <div *ngIf="shouldShowResumeButton()" [@inOutAnimation]>
      <div class="resume-info-text" style="margin: 15px;text-align: center;line-height: 22px;">
        You are viewing a previously reviewed document. We saved your place.
      </div>
      <div style="display: flex; justify-content: center; margin-bottom: 20px;">
        <lex-flat-button label="Resume workflow" [icon]="'fa-duotone fa-bullseye-pointer'" (click)="resume()"></lex-flat-button> 
      </div>
      <div class="resume-footer"></div>
    </div>
    <div *ngFor="let review of reviewDocs$ | async; trackBy: trackByDocId" class="reviewed-docs" [ngClass]="{'active': review.docId === currentDocumentId,
            'child': review.relationship === 'child',
            'reviewed': review.hasBeenReviewed,
            'attention': review.docId === pointerDocId}" (mouseover)="pointerDocId = review.docId"
      (mouseleave)="pointerDocId = ''" (click)="goToDocument(review.docId)">
      <div class="reviewed-docs-content">
        <lex-doc-node [node]="toDocContextDoc(review)" [isSelected]="review.docId === currentDocumentId"
          style="cursor: pointer; overflow:auto;"></lex-doc-node>
        <div (click)="toggleValitaionMessage(review.docId);$event.stopPropagation();"
          matTooltip="Click to toggle validation message" style="cursor: pointer;">
          <div *ngIf="review.validationStatus !== ValidationStatus.None" style="display: flex; align-items: center;">
            <div class="fa-duotone fa-circle-info validation-notification"></div>
          </div>
        </div>
      </div>
      <div *ngIf="showValiationMessageReviewDocId === review.docId">
        <lex-doc-validation-message [validationErrors]="review.validationErrors"></lex-doc-validation-message>
      </div>
    </div>
  </div>


</lex-doc-viewer-context-panel-template>
